import { Action } from '@ngrx/store';
import { cuenta } from 'src/app/models/SicarMap/cuenta.model';
import { resetPassword } from '../../../models/SicarMap/Inicio/resetPassword.model';


export enum ForgotActionTypes {
  FORGOT = '[Auth] Forgot',
  FORGOT_SUCCESS = '[Auth] Forgot Success',
  FORGOT_FAILURE = '[Auth] Forgot Failure',
  LOGOUT = '[Auth] Logout',
}

export class Forgot implements Action {
  readonly type = ForgotActionTypes.FORGOT;
  constructor(public CredencialesF: resetPassword) { }
}

export class ForgotSuccess implements Action {
  readonly type = ForgotActionTypes.FORGOT_SUCCESS;
  constructor(public DatosCuenta: any) { }
}

export class ForgotFailure implements Action {
  readonly type = ForgotActionTypes.FORGOT_FAILURE;
  constructor(public payload: any) { }
}


export type forgotAcciones =
  | Forgot
  | ForgotSuccess
  | ForgotFailure;

